// @flow
import ReactGA from "react-ga4";
import type {Tracking} from "../../models/Tracking";
import GoogleBaseTracker from "./GoogleBaseTracker";

export default class GoogleTracker extends GoogleBaseTracker implements Tracking {
    constructor(trackingIds: string[], withEcommerce: boolean = false, dealerId: string = "unknown", dealerName: string = "unknown", customerNo: string = "unknown") {
        super(trackingIds[0], withEcommerce);
        if (navigator.doNotTrack === "1") {
            window[`ga-disable-${this.trackingId}`] = true;
        }
        // named config parameters, identical to the GTM variant (GA4 has no
        // "dimensionN" syntax — that was Universal Analytics).
        // page views use Google's default behaviour (automatic initial page_view;
        // in-module navigation via Enhanced Measurement in the GA4 property)
        const gtagOptions = {
            "dealerId": dealerId,
            "dealerName": dealerName,
            "customerNo": customerNo,
        };

        ReactGA.initialize(trackingIds
                .map(id => ({
                    trackingId: id,
                    gaOptions: {},
                    gtagOptions
                })),
            {
                testMode: false,
            }
        );
    }

    send(eventName: string, payload: ?{}) {
        ReactGA.event(eventName, payload);
    }
}
